import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import axios from "axios";
import jwt_decode from "jwt-decode";
import { ToastContainer } from 'react-toastify';
import { Provider } from "react-redux";
import store from './redux/store'

import './scss/main.scss'
import 'react-toastify/dist/ReactToastify.css';  

import setAuthToken from './utils/setAuthToken';
import { setCurrentUser, _LOGOUT } from './redux/auth/authActions';

import Layout from "./pages/Layout";
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';



if(localStorage.jwtToken){
  let token = localStorage.jwtToken;

  setAuthToken(token)

  const decoded = jwt_decode(token)

  store.dispatch(setCurrentUser(decoded))

  token = token.split(' ')[1]
    
  const currentTime = Date.now() / 1000; // to get in milliseconds
      
      
  if (decoded.exp < currentTime) {
    // Logout user

    store.dispatch(_LOGOUT())
    // Redirect to login
    window.location.reload();
  }
    

}

axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
 if (error.response.status === 401) {
    store.dispatch(_LOGOUT())
     window.location.reload()
 }

 return Promise.reject(error);
});



function App() {
  return (
   <Provider store={store}>
   <ToastContainer/>
    <Router>
      <Routes>
        <Route path='/signin' element={<Login />}></Route>
        <Route path='/' element={<Signup />}></Route>
        <Route path='/forgot-password' element={<ForgotPassword />}></Route>
        <Route path="/dashboard" element={<Layout />}></Route>
      </Routes>
    </Router>
   </Provider>
  );
}

export default App;
